import { FC, memo, useRef } from 'react';
import { ActionMeta, Props } from 'react-select';
import AsyncSelect from "react-select/async";

interface ComboboxProps extends Props {
    label?: string,
    name?: string,
    nameErrorMessage?: string,
    touched?: any,
    noDataMessage?: string,
    required?: boolean,
    isCallApi?: boolean,
    params?: object,
    fieldSearch?: string,
    valueField?: string,
    displayField?: string,
    placeholder?: string
    handleChange?: ((newValue: any, actionMeta?: ActionMeta<any>) => void) | undefined;
    service?: (param: any) => Promise<any>
    optionsResponse?: string
    getOptionLabel?: any
};

const convertNameUrl = (value: string, item: any) => {
    const array = value.split(".")
    for (let i = 0; i < array.length; i++) {
      item = item?.[array[i]];
    }
    return item
  }

const customStyles = (nameErrorMessage: string) => ({
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        height: '30px',
        minHeight: '30px',
        borderColor: nameErrorMessage ? "red" : "#CDE4DA",
        boxShadow: 'none',
        color: 'var(--kt-input-color)',
        '&:hover': {
            borderColor: state.isFocused ? null : '#ced4da',
        }
    }),
    valueContainer: (baseStyles: any, state: any) => ({
        ...baseStyles,
        height: '30px',
    }),
    indicatorsContainer: (baseStyles: any, state: any) => ({
        ...baseStyles,
        height: '30px',
    }),
    input: (baseStyles: any, state: any) => ({
        ...baseStyles,
        margin: '0px',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    })
});

const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

const AsyncAutoComplete: FC<ComboboxProps> = (props) => {
    const {
        label,
        name,
        nameErrorMessage = "",
        touched = false,
        required = false,
        params,
        fieldSearch = 'keyword',
        valueField = 'id',
        displayField = 'label',
        noDataMessage = 'Nhập tên đơn vị để tìm kiếm...',
        optionsResponse = 'data',
        placeholder = 'Nhập tên đơn vị để tìm kiếm...',
        handleChange,
        service,
        getOptionLabel=(option: any): string => option[displayField],
        ...rest
    } = props;

    const fetchOptions = async (inputValue: string) => {
        try {
            if (service) {
                const response = await service({ [fieldSearch]: inputValue, ...params });
                const data = response?.data;
                return convertNameUrl(optionsResponse, data) || data || []
            }
            return [];
        } catch {
            return [];
        }
    };

    const debouncedFetchOptions = debounce((inputValue: string, callback: (options: any[]) => void) => {
        fetchOptions(inputValue).then(callback);
    }, 1000);

    const loadOptions = (inputValue: string, callback: (options: any[]) => void) => {
        if (inputValue?.length >= 2) { // do dai input lon hon 2 moi bat dau call API
            debouncedFetchOptions(inputValue, callback);
        } else {
            callback([]);
        }
    };

    const getOptionValue = (option: any): string => option[valueField];
    const noOptionsMessage = () => noDataMessage;

    return (
        <div>
            <span className={`text-lable-input lable`}>
                {label}
                {required && <span className="color-red"> *</span>}
            </span>
            <AsyncSelect
                {...rest}
                styles={customStyles(nameErrorMessage)}
                name={name}
                cacheOptions
                placeholder={placeholder}
                loadOptions={loadOptions}
                getOptionValue={getOptionValue}
                getOptionLabel={getOptionLabel}
                noOptionsMessage={noOptionsMessage}
                className='autocomplete-custom '
                classNamePrefix='select'
                onChange={handleChange}
            />
            {touched && nameErrorMessage &&
                <div className="error-message text-danger">{nameErrorMessage}</div>
            }
        </div>
    );
}

export default memo(AsyncAutoComplete);
